import { mapActions } from 'vuex'

export default {
  name: 'Register',
  data: () => {
    return {
      email: '',
      firstName: '',
      lastName: '',
      customerName: '',
      telephone: '',
      password: '',
      password2: '',
      showRegistrationForm: false,
      showInfoForm: false
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => !x.valid)
    }
  },
  methods: {
    register () {
      if (this.isInvalid) return
      const accountInfo = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        customerName: this.customerName,
        telephone: this.telephone,
        password: this.password,
        password2: this.password2
      }
      this.registerUser(accountInfo)
        .then(() => {
          this.showInfoForm = true
          this.showRegistrationForm = false
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    showRegistration () {
      this.showRegistrationForm = true
    },
    ...mapActions({
      registerUser: 'REGISTER_USER'
    })
  }
}
